import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { Code } from '#app/components/typography/code.tsx'
import { P } from '#app/components/typography/p.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Code',
}

const component: componentProps = {
	name: 'Code',
	shortName: 'Code',
	fileName: 'code',
	category: 'typography',
	description: ['Code component.'],
	features: ['Drop-in replacement for the native <code> element.', "Opts-in to your design system's typographic styles."],
	parts: [],
	usage: `<P>
	We all know <Code>console.log()</Code> is the best way to debug.
</P>`,
	styling: `:not(.pre) > .code {
	@apply bg-muted-200 text-muted-900 py-fluid-2 px-fluid-5 rounded-md;
}`,
}

export const loader = async () => json({ source: await readSource({ category: component.category, fileName: component.fileName }) })

const TextRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<P>
				We all know <Code>console.log()</Code> is the best way to debug.
			</P>
			<Features features={features} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default TextRoute
